import { SxProps, Theme } from "@mui/material";

export function statusDialogTitle(theme: Theme): SxProps<Theme> {
    return {
        m: 0,
        p: 2,
    };
}

export function closeDialogIconButton(theme: Theme): SxProps<Theme> {
    return {
        position: "absolute",
        right: 8,
        top: 8,
        color: "grey",
        marginTop: "4px",
    };
}
